import React, { Component } from 'react'
import './index.css'

export default class Spinner extends Component {
  state = {
    intervalList: []
  }

  componentDidMount() {
    if (this.props.show) this.show();
  }

  show() {
    this.state.intervalList.forEach(x => clearInterval(x))

    this.setState({intervalList: []}, () => {
      const self = this.self;
      self.classList.add("ripple-show")
      this.state.intervalList.push(
        setTimeout(() => {
          self.classList.remove("ripple-show")
        }, 500)
      )
    })
  }

  render() {
    return (
      <div
        className="ripple"
        ref={ref => this.self = ref}>
        <div />
        <div />
      </div>
    )
  }
}
